<template>
  <div>
    <h1> Failed</h1>
  </div>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      
    };
  },

  

  methods: {
   
  }
};
</script>

<style>
</style>
